export enum walletTypesFilter {
  transactions = "transactions",
}
